var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "both-pd-box" }, [
    _c(
      "div",
      {
        staticStyle: {
          background: "#fff",
          padding: "30px",
          "border-radius": "20px",
        },
      },
      [
        _c("h3", [_vm._v("基础配置")]),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "ruleForm20",
            staticClass: "demo-ruleForm",
            staticStyle: { width: "60%" },
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              "label-width": "150px",
            },
          },
          [
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "升级赚模块" },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.ruleForm.upgradeModuleStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "upgradeModuleStatus", $$v)
                      },
                      expression: "ruleForm.upgradeModuleStatus",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("打开")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tips" }, [
                  _vm._v(
                    "用户协议设置方式：先去活动管理-自定义页面-创建“用户协议”页，创建后复制卡片链接配置到此即可。"
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "升级赚展示等级" },
              },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "用户等级", clearable: "" },
                    model: {
                      value: _vm.ruleForm.lessThanGrade,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "lessThanGrade", $$v)
                      },
                      expression: "ruleForm.lessThanGrade",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.name, value: item.grade },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tips" }, [
                  _vm._v(
                    "选择特定等级后，低于当前等级的用户会展示升级赚功能，高于当前等级的会隐藏升级赚功能"
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "升级赚文案" },
              },
              [
                _c("el-input", {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.ruleForm.upgradeText,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "upgradeText", $$v)
                    },
                    expression: "ruleForm.upgradeText",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "tips" }, [
                  _vm._v(
                    "配置文案时可选择两个变量  #等级# 和 #佣金#，可以按照实际设置的等级，自动计算并展示对应的商品佣金"
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "推广素材" },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.ruleForm.materiaStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "materiaStatus", $$v)
                      },
                      expression: "ruleForm.materiaStatus",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("打开")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.ruleForm.materiaStatus === 1
                  ? _c(
                      "div",
                      [
                        _c("el-image", {
                          staticStyle: { width: "40%", display: "block" },
                          attrs: {
                            src: require("@/assets/lizi2.png"),
                            "preview-src-list": [require("@/assets/lizi2.png")],
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "历史价格趋势" },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.ruleForm.historyPriceStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "historyPriceStatus", $$v)
                      },
                      expression: "ruleForm.historyPriceStatus",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("打开")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.ruleForm.historyPriceStatus === 1
                  ? _c(
                      "div",
                      [
                        _c("el-image", {
                          staticStyle: { width: "40%", display: "block" },
                          attrs: {
                            src: require("@/assets/lizi1.png"),
                            "preview-src-list": [require("@/assets/lizi1.png")],
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticStyle: { "margin-top": "30px" },
                attrs: { label: "优惠券主题样式" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-start",
                      "flex-wrap": "wrap",
                    },
                  },
                  _vm._l(6, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          width: "32%",
                          "margin-right": "10px",
                          "text-align": "center",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("el-image", {
                              staticStyle: { width: "100%", display: "block" },
                              attrs: {
                                src: require("@/assets/counp" +
                                  (index + 1) +
                                  ".png"),
                                "preview-src-list": [
                                  require("@/assets/counp" +
                                    (index + 1) +
                                    ".png"),
                                ],
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-radio",
                          {
                            attrs: { label: index + 1 },
                            model: {
                              value: _vm.ruleForm.couponStyle,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "couponStyle", $$v)
                              },
                              expression: "ruleForm.couponStyle",
                            },
                          },
                          [_vm._v("样式" + _vm._s(index + 1))]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticStyle: { "margin-top": "60px" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "200px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitForm("ruleForm20")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }